import { render, staticRenderFns } from "./formSubscriptionLayoutPage.vue?vue&type=template&id=f4897bfe&scoped=true&"
import script from "./formSubscriptionLayoutPage.vue?vue&type=script&lang=js&"
export * from "./formSubscriptionLayoutPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4897bfe",
  null
  
)

export default component.exports